<template>
  <div class="ui-pannel">
    <p class="title">{{$t("myteacher")}}</p>
    <div class="content">
      <ul class="tabs">
        <!-- <li :class="{on: tab === 0}" @click="changeTab(0)">全部</li> -->
        <li :class="{on: tab === 0}" @click="changeTab(0)">{{$t("booked")}}</li>
        <li :class="{on: tab === 2}" @click="changeTab(2)">{{$t("follow")}}</li>
      </ul>
      <div class="list" v-show="teachers.length !== 0">
        <div class="cell" v-for="(item, index) in teachers" :key="index">
          <div class="card" @click="goDetail(item.teacherId)">
            <div class="avatar">
              <el-image :src="item.teacherUserPicUrl" fit="cover" class="img" v-if="tab === 1" alt="" />
              <el-image :src="item.teacherPhotoUrl" fit="cover" class="img" v-else alt="" />
              <span class="detail">{{$t('detail')}}</span>
            </div>
            <p class="info">
              <span class="txt">{{item.teacherName}}</span>
              <!-- <span class="txt">高级</span>
              <span class="txt">教师</span> -->
            </p>
            <p class="desc">
              <!-- <span class="txt">{{item.languageList}}</span> -->
              <span class="txt" style="margin-top:10px;display:block;">{{$t('teaching')}} {{item.teachingExperience}} {{$t('year')}}</span>
            </p>
          </div>
        </div>
        <template v-if="teachers.length > 4">
          <hr v-for="n in (Math.ceil(teachers.length / 4) - 1)" :key="n" :style="{top: 340 * n + 'px'}">
        </template>
      </div>
      <div class="ui-empty" v-show="teachers.length === 0"></div>
    </div>
  </div>
</template>
<script>
import {getMyTeacherList, getMyFollowTeacherList, getStudentStudyCourseList} from '@/service/studentApi.js'
export default {
  data(){
    return {
      tab: 0,
      teachers: []
    }
  },
  mounted(){
    this.getMyTeacherList()
  },
  methods: {
    async getMyTeacherList(){
      let res = await getMyTeacherList()
      if(res.data.status === 1){
        // console.log(res)
        this.teachers = res.data.data
        this.$forceUpdate()
      }
    },
    async getMyFollowTeacherList(){
      let res = await getMyFollowTeacherList()
      if(res.data.status === 1){
        this.teachers = res.data.data
        this.$forceUpdate()
      }
    },
    async getStudentStudyCourseList(){
      let res = await getStudentStudyCourseList({state: 1, studentId: this.user.uid, pageNO: 1, pageSize: 100, totalCount: 0})
      if(res.data.status === 1){
        this.teachers = res.data.data
        this.$forceUpdate()
      }
    },
    changeTab(n){
      this.tab = n
      if(n === 2){
        this.getMyFollowTeacherList()
      }else if(n === 1){
        this.getStudentStudyCourseList()
      }else if(n === 0){
        this.getMyTeacherList()
      }
    },
    goDetail(id){
      this.$router.push({path: '/teachers/teacherDetail', query: {id: id}})
    }
  },
  computed: {
    user(){
      return JSON.parse(this.$store.getters.GETUSER)
    }
  }
}
</script>
<style lang="scss" scoped>
.content{padding: 30px 50px 20px;}
.tabs{
  display: flex;
  li{
    margin-right: 10px; width: 180px; height: 42px; line-height: 42px; border-radius: 12px 12px 0 0; text-align: center; background: #A9C4B1; color: #fff; cursor: pointer;
    &.on{background: #002147;}
  }
}
.list{
  position: relative; display: flex; flex-wrap: wrap; margin-right: -20px;
  .cell{padding: 50px 0; text-align: center; margin-right: 20px;}
  .card{
    width: 192.5px; min-height: 240px; background: #FBFBFB; border-radius: 5px; padding: 45px 10px 20px; cursor: pointer; transition: all .3s;
    &:hover{background: #fff; box-shadow: 0 3px 21px rgba($color: #7B7B7B, $alpha: .16);}
  }
  .avatar{
    margin: 0 auto; width: 90px; height: 90px; border-radius: 50%; font-size: 0; overflow: hidden; position: relative;
    &:hover .detail{display: block;}
    .img{width: 100%; height: 100%;}
  }
  img{width: 100%; height: 100%;}
  .info{font-size: 16px; line-height: 21px; margin-top: 20px;}
  .desc{color: #999; line-height: 19px;}
  // .txt{margin: 0 5px;}
  hr{position: absolute; left: 0; right: 20px; border: 1px dashed #707070; top: 340px;}
  .detail{position: absolute; bottom: 0; left: 0; right: 0; height: 35px; line-height: 35px; text-align: center; color: #fff; background: rgba($color: #2680eb, $alpha: .55); font-size: 14px; display: none;}
}
</style>
<i18n>
{
  "cn": {
    "booked": "已报名",
    "follow": "仅关注",
    "detail":"详情",
    "teaching":"执教"
  },
  "TW": {
    "booked": "已報名",
    "follow": "僅關注",
    "detail":"詳情",
    "teaching":"執教"
  },
  "en": {
    "booked": "Booked ",
    "follow": "Followed",
    "detail":"Detail",
    "teaching":"Teaching"
  }
}
</i18n>